<template>
<div class="cigo-layer-confirm">
    <div class="title-area">
        <span>{{layerData.title ? layerData.title : '提 示'}}</span>
    </div>
    <div class="content-layer">
        <span class="msg">{{layerData.msg}}</span>
    </div>
    <div class="btn-area">
        <a-button-group>
            <a-button type="primary" @click.stop="ok">确定</a-button>
            <a-button v-if="layerData.showCancel" type="default" @click.stop="cancel">取消</a-button>
        </a-button-group>
    </div>
</div>
</template>

<script lang="ts">
import {
    defineComponent,
    ref
} from "vue";
import cigoLayer from "./layer";

export default defineComponent({
    name: "CigoLayerConfirm",
    props: {
        layerData: {
            type: Object,
            default: {}
        }
    },
    setup(props, ctx) {
        const ok = () => {
            //Tips_Flag 探秘Promise的用法：答疑antdesign的点击不同结果事件
            new Promise((resolve, reject) => {
                    ctx.emit("notify", "ok", resolve, reject);
                })
                .then(() => {
                    ctx.emit("close");
                })
                .catch(() => {
                    console.log("hold on");
                });
        };

        const cancel = () => {
            new Promise((resolve, reject) => {
                    ctx.emit("notify", "cancel", resolve, reject);
                })
                .then(() => {
                    ctx.emit("close");
                })
                .catch(() => {
                    console.log("hold on");
                });
        };

        return {
            ok,
            cancel
        };
    }
});
</script>

<style lang="scss">
.cigo-layer-confirm {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;

    .title-area {
        background-color: #f5f5f5;
        border-bottom: 1px solid #f0f0f0;
        padding: 15px 12px;
        display: flex;
        border-top-left-radius: 8px;
        border-top-right-radius: 8px;
        flex-direction: row;
        justify-content: center;
        font-size: 16px;
    }

    .content-layer {
        display: flex;
        flex-direction: column;
        width: 100%;
        flex: 1;
        padding: 12px 10px;
        overflow-x: hidden;
        overflow-y: scroll;

        .msg {
            line-height: 30px;
            color: #666;
            font-size: 14px;
            text-align: center;
        }
    }

    .btn-area {
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        padding: 8px 12px;
        border-top: 1px solid #f0f0f0;
    }
}
</style>
